export function calculateEffectiveCoveragePercentage(fullFee, companyOwes, fallback = 0) {
  const full = Number(fullFee);
  const company = Number(companyOwes);

  if (Number.isFinite(full) && full > 0 && Number.isFinite(company)) {
    const boundedCompany = Math.min(full, Math.max(0, company));
    return Math.round(((boundedCompany / full) * 100) * 100) / 100;
  }

  const fallbackNumber = Number(fallback);
  if (!Number.isFinite(fallbackNumber)) return 0;
  return Math.min(100, Math.max(0, fallbackNumber));
}
